// eslint-disable-next-line import/no-cycle
import HTTP from '../http/common';

export default {
  init() {
    return HTTP.post('Onboarding/init');
  },
  savestep1(data) {
    return HTTP.post('Onboarding/savestep1', data);
  },
  savestep2(data) {
    return HTTP.post('Onboarding/savestep2', data);
  },
  warzoneStats() {
    return HTTP.get('Onboarding/warzoneStats');
  },

  backToStep(step) {
    return HTTP.get(`Onboarding/backtostep/${step}`);
  },
  request() {
    return HTTP.get('Onboarding/request');
  },
};
